<template>
  <div class="row transaction">
    <div class="spinner-grow" role="status" v-if="loading === true"></div>
    <div class="alert alert-danger" role="alert" v-if="error === true">
      {{ errorMsg }}
    </div>

    <div style="display: flex">
      <div class="col-auto mt-2">
        <label>Start Date</label>
        <div class="input-group mb-2">
          <input
            type="date"
            class="form-control"
            id="inlineFormInputGroup"
            placeholder="Start Date"
            v-model="startDate"
          />
        </div>
      </div>
      <div class="col-auto mt-2">
        <label>End Date</label>
        <div class="input-group mb-2">
          <input
            type="date"
            class="form-control"
            id="inlineFormInputGroup"
            placeholder="End Date"
            v-model="endDate"
          />
        </div>
      </div>
      <div class="col-auto mt-2">
        <button class="btn btn-primary mb-2 mt-4" @click="refresh('refresh')">
          Refresh
        </button>
      </div>
      <div class="col-auto mt-2">
        <label>First Name</label>
        <div class="input-group mb-2">
          <input
            type="text"
            class="form-control"
            id="inlineFormInputGroup"
            placeholder="Merchant Name"
            v-model="firstName"
          />
        </div>
      </div>

      <div class="col-auto mt-2">
        <button
          type="submit"
          class="btn btn-primary mb-2 mt-4"
          @click="refresh('filter')"
        >
          Filter
        </button>
      </div>
      <div class="col-auto mt-2">
        <button class="btn btn-primary mb-2 mt-4" @click="refresh('download')">
          Download list
        </button>
      </div>
    </div>

    <div class="col-12">
      <card class="card-plain">
        <div class="table-full-width table-responsive">
          <table class="table">
            <thead class="thead-dark">
              <tr>
                <th scope="col" class="text-center">S/N</th>
                <th scope="col" class="text-center">First Name</th>
                <th scope="col" class="text-center">Last Name</th>
                <th scope="col" class="text-center">Wallet Id</th>
                <!-- <th scope="col" class="text-center">Balance</th> -->
                <th scope="col" class="text-center">Business Name</th>
                <th scope="col" class="text-center">Phone Number</th>
                <th scope="col" class="text-center">State</th>
                <th scope="col" class="text-center">Activited By</th>
                <th scope="col" class="text-center">Activited Date</th>
                <th scope="col" class="text-center">Created At</th>
                <!-- <th scope="col" class="text-center">Action</th> -->
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="(agent, index) in agentList"
                :key="agent._id"
                style="background-color: #fff"
              >
                <th class="text-center">
                  {{ limit * (page - 1) + (index + 1) }}
                </th>
                <td class="text-center">{{ agent.firstName }}</td>
                <td class="text-center">{{ agent.lastName }}</td>
                <td class="text-center">{{ agent.walletId }}</td>
                <!-- <td class="text-center">{{ agent.balance }}</td> -->
                <td class="text-center">{{ agent.businessName }}</td>
                <td class="text-center">{{ agent.phoneNumber }}</td>
                <td class="text-center">{{ agent.state }}</td>
                <td class="text-center">{{ agent.activitedBy }}</td>
                <td class="text-center" v-if="agent.activatedAt">
                  {{ moment(agent.activatedAt).format("DD-MM-YYYY") }}
                </td>
                <td class="text-center" v-else>Inactive</td>
                <td class="text-center">
                  {{ moment(agent.createdAt).format("DD-MM-YYYY") }}
                </td>
                <!-- <td class="text-center">
                  <router-link :to="`/dashboard/agent/${agent._id}`"
                    >View Details</router-link
                  >
                </td> -->
              </tr>
            </tbody>
          </table>
        </div>
      </card>
    </div>

    <div class="mt-2 paginate-btns">
      <div class="p-2" v-if="hasPrevPage === true">
        <button
          type="submit"
          class="btn btn-primary mb-2 mt-4"
          @click="refresh('previous')"
        >
          Previous Page
        </button>
      </div>
      <div>Page {{ currentPage }} of {{ totalPages }}</div>
      <div class="p-2" v-if="hasNextPage === true">
        <button
          type="submit"
          class="btn btn-primary mb-2 mt-4"
          @click="refresh('next')"
        >
          Next Page
        </button>
      </div>
    </div>
    <div class="mt-2 d-flex justify-content-end align-items-center">
      <div class="p-2">
        <div class="btn">Total Records: {{ totalDocs }}</div>
      </div>
    </div>
  </div>
</template>
<script>
import axios from "../store/axios";
import moment from "moment";
import { convertArrayToCSV } from "convert-array-to-csv";
import fileDownload from "js-file-download";
export default {
  data() {
    return {
      currentPage: 1,
      loading: false,
      error: false,
      errorMsg: "",
      moment,
      format: new Intl.NumberFormat("en-US", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      }),
      page: 1,
      limit: 50,
      totalPages: 0,
      totalDocs: 0,
      hasPrevPage: false,
      hasNextPage: false,
      prevPage: null,
      nextPage: null,
      agentList: [],
      filteredAgentList: [],
      startDate: null,
      endDate: null,
      download: false,
      firstName: "",
    };
  },
  methods: {
    handleSearch(term) {
      if (term) {
        this.filteredAgentList = this.agentList.filter((agent) => {
          let firstNameMatch;
          let lastNameMatch;
          let businessNameMatch;
          if (agent.firstName) {
            firstNameMatch = agent.firstName
              .toLowerCase()
              .includes(term.toLowerCase());
          }
          if (agent.lastName) {
            lastNameMatch = agent.lastName
              .toLowerCase()
              .includes(term.toLowerCase());
          }
          if (agent.businessName) {
            businessNameMatch = agent.businessName
              .toLowerCase()
              .includes(term.toLowerCase());
          }
          return firstNameMatch || lastNameMatch || businessNameMatch;
        });
      } else {
        // If the search term is empty, show the complete agent list
        this.filteredAgentList = this.agentList;
      }
    },
    async refresh(mode) {
      try {
        this.errorMsg = "";
        this.error = false;
        this.loading = true;
        let payload = {
          page: this.page,
          firstName: this.firstName,
          startDate: this.startDate,
          endDate: this.endDate,
          download: this.download,
        };
        switch (mode) {
          case "next":
            payload = { ...payload, page: this.nextPage };
            this.currentPage = this.nextPage;
            break;
          case "previous":
            payload = { ...payload, page: this.prevPage };
            this.currentPage = this.prevPage;
            break;
          case "download":
            payload = { ...payload, download: true };
            break;
          case "filter":
            let tempAgentList = this.agentList.filter((agent) => {
              let agentDate = new Date(agent.createdAt);
              return (
                agentDate >= new Date(this.startDate) &&
                agentDate <= new Date(this.endDate)
              );
            });
            this.filteredAgentList = tempAgentList;
            break;
        }

        const res = await axios.post(
          `${process.env.VUE_APP_API_URL}/agent-list`,

          payload,
        );
        if (mode === "download") {
          const csvTran = convertArrayToCSV(res.data.agentList);
          fileDownload(csvTran, "agents_list.csv");
        } else {
          const {
            docs,
            hasNextPage,
            hasPrevPage,
            totalPages,
            prevPage,
            nextPage,
            totalDocs,
            page,
          } = res.data.agentList;
          this.agentList = docs;
          this.filteredAgentList = docs;
          this.hasPrevPage = hasPrevPage;
          this.hasNextPage = hasNextPage;
          this.totalPages = totalPages;
          this.prevPage = prevPage;
          this.nextPage = nextPage;
          this.totalDocs = totalDocs;
          this.page = page;
        }
      } catch (err) {
        console.log(err);
        this.error = true;
        this.errorMsg = "Unable to Download Agents List";
      }
      this.loading = false;
    },
    //   nextPage() {
    //     if (this.currentPage < this.totalPages) {
    //       this.currentPage++;
    //       this.refresh();
    //     }
    //   },
  },
  async mounted() {
    try {
      this.loading = true;
      const res = await axios.post(
        `${process.env.VUE_APP_API_URL}/merchant/agents`,
        {
          page: this.page,
          // limit: this.limit,
          // startDate: this.startDate,
          // endDate: this.endDate,
        },
      );
      const {
        docs,
        hasNextPage,
        hasPrevPage,
        totalPages,
        prevPage,
        nextPage,
        totalDocs,
        page,
      } = res.data.agentList;
      this.agentList = docs;
      this.filteredAgentList = docs;
      this.hasPrevPage = hasPrevPage;
      this.hasNextPage = hasNextPage;
      this.totalPages = totalPages;
      this.prevPage = prevPage;
      this.nextPage = nextPage;
      this.totalDocs = totalDocs;
      this.page = page;
    } catch (err) {
      console.log(err);
      this.error = true;
      this.errorMsg = "Unable to Fetch Agents";
    }
    this.loading = false;
  },
};
</script>
<style scoped>
.transaction {
  font-size: 12px;
}
th {
  font-size: 12px !important;
}
.spinner-grow {
  position: fixed;
}
#list {
  list-style-type: none;
}
</style>
